import {
  SET_MOBILE_MENU_OPEN,
  SET_ONBOARDING_CHECK_PENDING,
  SET_REDIRECT_PATH,
  SET_THEME_MODE,
  ThemeModeEnum,
} from "_constants";

const initialState = {
  redirectPath: null,
  mobileMenuOpen: false,
  themeMode: ThemeModeEnum.LIGHT,
  onboardingCheckPending: false,
};

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REDIRECT_PATH: {
      return {
        ...state,
        redirectPath: action.payload,
      };
    }
    case SET_MOBILE_MENU_OPEN: {
      return {
        ...state,
        mobileMenuOpen: action.payload,
      };
    }

    case SET_THEME_MODE: {
      return {
        ...state,
        themeMode: action.payload,
      };
    }

    case SET_ONBOARDING_CHECK_PENDING: {
      return {
        ...state,
        onboardingCheckPending: action.payload,
      };
    }

    default:
      return state;
  }
};

export default mainReducer;
